export function isUnsafeInteger(value: unknown) {
  if (value === null) return value;

  const num = Number(value);

  if (isNaN(num)) {
    return null;
  }

  return num > Number.MAX_SAFE_INTEGER || num < Number.MIN_SAFE_INTEGER;
}

export function isUnsafeNumber(value: unknown) {
  if (value === null) return value;

  const num = Number(value);

  if (isNaN(num)) {
    return null;
  }

  // operations reducing a value past the lowest possible representable number,
  // such as Number.MIN_VALUE - {number}, will resolve to {number} alone,
  // because of loss of precision
  if (num + 1 === Number.MAX_VALUE || (num !== 0 && num - 1 === -1))
    return true;

  return (
    num > Number.MAX_VALUE ||
    num < -Number.MAX_VALUE ||
    (num > -Number.MIN_VALUE && num < 0) ||
    (num < Number.MIN_VALUE && num > 0)
  );
}

export function isSmallNumber(value: number, threshold = 0.001) {
  return Math.abs(value) > 0 && Math.abs(value) < Math.abs(threshold);
}
